import { createFileRoute } from "@tanstack/react-router";
import { BlogIndexPage, blogIndexHead } from "@/pages/BlogIndexPage";

export const Route = createFileRoute("/de/artikel/")({
  head: () => blogIndexHead("de"),
  component: () => <BlogIndexPage locale="de" />,
});
